export default function deleteObjectProperty(key, {[key]: deletedKey, ...restObject}){
    return restObject;
}